import { render, staticRenderFns } from "./CondicionIvaVSelect.vue?vue&type=template&id=31c2b1e8&scoped=true&"
import script from "./CondicionIvaVSelect.vue?vue&type=script&lang=js&"
export * from "./CondicionIvaVSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c2b1e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
